import { render, staticRenderFns } from "./PurchaseSummary.vue?vue&type=template&id=71eee00f&scoped=true"
import script from "./PurchaseSummary.vue?vue&type=script&lang=js"
export * from "./PurchaseSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eee00f",
  null
  
)

export default component.exports